import { render, staticRenderFns } from "./EditarAlarma.vue?vue&type=template&id=6caa61c0&"
import script from "./EditarAlarma.vue?vue&type=script&lang=ts&"
export * from "./EditarAlarma.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6caa61c0', component.options)
    } else {
      api.reload('6caa61c0', component.options)
    }
    module.hot.accept("./EditarAlarma.vue?vue&type=template&id=6caa61c0&", function () {
      api.rerender('6caa61c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfiguracionAlarmas/EditarAlarma.vue"
export default component.exports